import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Empty state component displayed when no tile is selected.
 * Prompts the user to select a tile to view distinct values.
 */
const EmptyTileState: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 610,
      p: 4,
    }}
  >
    <Typography variant="body1" color="text.secondary">
      Please select a filter to view distinct values
    </Typography>
  </Box>
);

export default EmptyTileState;
